import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Antd from 'ant-design-vue';
import { IonButton, IonButtons, IonContent, IonicVue, IonPage } from "@ionic/vue";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
  
/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css";


/* Theme variables */
import ElementPlus, { ElMessage } from 'element-plus'
import 'element-plus/theme-chalk/index.css'
import "./theme/variables.css";
import "lib-flexible"
const app = createApp(App).use(IonicVue).use(Antd).use(router).use(ElementPlus);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

router.isReady().then(() => {
  app.mount("#app");
});

router.beforeEach((to,from,next)=>{
  let token = localStorage.getItem("token");
  if(token){
    // next放行
    next();
  }else{
    if(to.fullPath === '/login'){
      next();
    }else{
      ElMessage.error('请先登录')
      next("/login");
    }
  }
  
})
